import AudioLinesIconUrl from 'lucide-static/icons/audio-lines.svg?url';
import AwardIconUrl from 'lucide-static/icons/award.svg?url';
import BinaryIconUrl from 'lucide-static/icons/binary.svg?url';
import BinocularsIconUrl from 'lucide-static/icons/binoculars.svg?url';
import BitcoinIconUrl from 'lucide-static/icons/bitcoin.svg?url';
import BlendIconUrl from 'lucide-static/icons/blend.svg?url';
import BoltIconUrl from 'lucide-static/icons/bolt.svg?url';
import BookOpenCheckIconUrl from 'lucide-static/icons/book-open-check.svg?url';
import BookOpenIconUrl from 'lucide-static/icons/book-open.svg?url';
import BotMessageSquareIconUrl from 'lucide-static/icons/bot-message-square.svg?url';
import BotIconUrl from 'lucide-static/icons/bot.svg?url';
import BrainIconUrl from 'lucide-static/icons/brain.svg?url';
import BrickWallFireIconUrl from 'lucide-static/icons/brick-wall-fire.svg?url';
import BriefcaseIconUrl from 'lucide-static/icons/briefcase.svg?url';
import Building2IconUrl from 'lucide-static/icons/building-2.svg?url';
import CalendarIconUrl from 'lucide-static/icons/calendar.svg?url';
import ChartNoAxesCombinedIconUrl from 'lucide-static/icons/chart-no-axes-combined.svg?url';
import ClipboardCheckIconUrl from 'lucide-static/icons/clipboard-check.svg?url';
import CloudSunIconUrl from 'lucide-static/icons/cloud-sun.svg?url';
import CloudUploadIconUrl from 'lucide-static/icons/cloud-upload.svg?url';
import CloudIconUrl from 'lucide-static/icons/cloud.svg?url';
import CodeIconUrl from 'lucide-static/icons/code.svg?url';
import CompassIconUrl from 'lucide-static/icons/compass.svg?url';
import ComputerIconUrl from 'lucide-static/icons/computer.svg?url';
import ContactIconUrl from 'lucide-static/icons/contact.svg?url';
import ContainerIconUrl from 'lucide-static/icons/container.svg?url';
import DatabaseIconUrl from 'lucide-static/icons/database.svg?url';
import DumbbellIconUrl from 'lucide-static/icons/dumbbell.svg?url';
import FileSearchIconUrl from 'lucide-static/icons/file-search.svg?url';
import FileStackIconUrl from 'lucide-static/icons/file-stack.svg?url';
import FilmIconUrl from 'lucide-static/icons/film.svg?url';
import FlagTriangleRightIconUrl from 'lucide-static/icons/flag-triangle-right.svg?url';
import FlaskConicalIconUrl from 'lucide-static/icons/flask-conical.svg?url';
import Gamepad2IconUrl from 'lucide-static/icons/gamepad-2.svg?url';
import GitBranchIconUrl from 'lucide-static/icons/git-branch.svg?url';
import GlobeLockUrl from 'lucide-static/icons/globe-lock.svg?url';
import GraduationCapIconUrl from 'lucide-static/icons/graduation-cap.svg?url';
import HammerIconUrl from 'lucide-static/icons/hammer.svg?url';
import HeadsetIconUrl from 'lucide-static/icons/headset.svg?url';
import HeartIconUrl from 'lucide-static/icons/heart.svg?url';
import HouseIconUrl from 'lucide-static/icons/house.svg?url';
import ImageIconUrl from 'lucide-static/icons/image.svg?url';
import LandmarkIconUrl from 'lucide-static/icons/landmark.svg?url';
import LanguagesIconUrl from 'lucide-static/icons/languages.svg?url';
import MessageCircleIconUrl from 'lucide-static/icons/message-circle.svg?url';
import MessagesSquareIconUrl from 'lucide-static/icons/messages-square.svg?url';
import MicrochipIconUrl from 'lucide-static/icons/microchip.svg?url';
import MonitorPlayIconUrl from 'lucide-static/icons/monitor-play.svg?url';
import MonitorIconUrl from 'lucide-static/icons/monitor.svg?url';
import NavigationIconUrl from 'lucide-static/icons/navigation.svg?url';
import NotebookPenIconUrl from 'lucide-static/icons/notebook-pen.svg?url';
import PaletteIconUrl from 'lucide-static/icons/palette.svg?url';
import PencilIconUrl from 'lucide-static/icons/pencil.svg?url';
import PickaxeIconUrl from 'lucide-static/icons/pickaxe.svg?url';
import PlaneIconUrl from 'lucide-static/icons/plane.svg?url';
import ScaleIconUrl from 'lucide-static/icons/scale.svg?url';
import SearchIconUrl from 'lucide-static/icons/search.svg?url';
import ShieldIconUrl from 'lucide-static/icons/shield.svg?url';
import ShoppingBagIconUrl from 'lucide-static/icons/shopping-bag.svg?url';
import SpeechIconUrl from 'lucide-static/icons/speech.svg?url';
import SquareKanbanIconUrl from 'lucide-static/icons/square-kanban.svg?url';
import SquareTerminalIconUrl from 'lucide-static/icons/square-terminal.svg?url';
import StethoscopeIconUrl from 'lucide-static/icons/stethoscope.svg?url';
import TerminalIconUrl from 'lucide-static/icons/terminal.svg?url';
import TextIconUrl from 'lucide-static/icons/text.svg?url';
import VideoIconUrl from 'lucide-static/icons/video.svg?url';
import WaypointsIconUrl from 'lucide-static/icons/waypoints.svg?url';
import WorkflowIconUrl from 'lucide-static/icons/workflow.svg?url';

export const icons = {
  'audio-lines': AudioLinesIconUrl,
  award: AwardIconUrl,
  binary: BinaryIconUrl,
  binoculars: BinocularsIconUrl,
  bitcoin: BitcoinIconUrl,
  blend: BlendIconUrl,
  bolt: BoltIconUrl,
  'book-open': BookOpenIconUrl,
  'book-open-check': BookOpenCheckIconUrl,
  bot: BotIconUrl,
  'bot-message-square': BotMessageSquareIconUrl,
  brain: BrainIconUrl,
  'brick-wall-fire': BrickWallFireIconUrl,
  briefcase: BriefcaseIconUrl,
  'building-2': Building2IconUrl,
  calendar: CalendarIconUrl,
  'chart-no-axes-combined': ChartNoAxesCombinedIconUrl,
  'clipboard-check': ClipboardCheckIconUrl,
  cloud: CloudIconUrl,
  'cloud-sun': CloudSunIconUrl,
  'cloud-upload': CloudUploadIconUrl,
  code: CodeIconUrl,
  compass: CompassIconUrl,
  computer: ComputerIconUrl,
  contact: ContactIconUrl,
  container: ContainerIconUrl,
  database: DatabaseIconUrl,
  dumbbell: DumbbellIconUrl,
  'file-search': FileSearchIconUrl,
  'file-stack': FileStackIconUrl,
  film: FilmIconUrl,
  'flag-triangle-right': FlagTriangleRightIconUrl,
  'flask-conical': FlaskConicalIconUrl,
  'gamepad-2': Gamepad2IconUrl,
  'git-branch': GitBranchIconUrl,
  'globe-lock': GlobeLockUrl,
  'graduation-cap': GraduationCapIconUrl,
  hammer: HammerIconUrl,
  headset: HeadsetIconUrl,
  heart: HeartIconUrl,
  house: HouseIconUrl,
  image: ImageIconUrl,
  landmark: LandmarkIconUrl,
  languages: LanguagesIconUrl,
  'message-circle': MessageCircleIconUrl,
  'messages-square': MessagesSquareIconUrl,
  microchip: MicrochipIconUrl,
  monitor: MonitorIconUrl,
  'monitor-play': MonitorPlayIconUrl,
  navigation: NavigationIconUrl,
  'notebook-pen': NotebookPenIconUrl,
  palette: PaletteIconUrl,
  pencil: PencilIconUrl,
  pickaxe: PickaxeIconUrl,
  plane: PlaneIconUrl,
  scale: ScaleIconUrl,
  search: SearchIconUrl,
  shield: ShieldIconUrl,
  'shopping-bag': ShoppingBagIconUrl,
  speech: SpeechIconUrl,
  'square-kanban': SquareKanbanIconUrl,
  'square-terminal': SquareTerminalIconUrl,
  stethoscope: StethoscopeIconUrl,
  terminal: TerminalIconUrl,
  text: TextIconUrl,
  video: VideoIconUrl,
  waypoints: WaypointsIconUrl,
  workflow: WorkflowIconUrl,
};

export type IconName = keyof typeof icons;
